import Button from 'partial/components/Button';
import Form from 'partial/form/Form';
import qs from 'query-string';
// import make from 'assets/images/powered-by.svg';
import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import FormPassword from 'partial/form/FormPassword';
import { useResetPassword } from '../hooks';

function ResetPassword() {
  const location = useLocation();
  const history = useHistory();
  // Reset links are sent as /reset-password?token=...&email=...
  const params = qs.parse(location.search, { decode: false });
  const token = params.token ? decodeURIComponent(params.token) : '';
  const email = params.email ? decodeURIComponent(params.email) : '';

  const [isLoading, submit] = useResetPassword();

  const [form, setForm] = useState({
    password: '',
    password_confirmation: '',
  });

  const handleSubmit = () => {
    const payload = { ...form, token, email };
    submit(payload, () => {
      history.push('/');
    });
  };

  return (
    <div className="h-full flex flex-col bg-no-repeat bg-center bg-cover bg-gray-100">
      <div className="w-full max-w-lg m-auto relative">
        <div className="m-auto w-full p-10 rounded-none sm:rounded-3xl bg-white shadow-primary-xl relative z-20">
          <Form onSubmit={handleSubmit}>
            <div className="my-5 text-center text-3xl">
              Set your new password
            </div>
            <div className="space-y-4">
              <FormPassword
                name="password"
                onChange={setForm}
                value={form.password}
                label="New Password"
                placeholder="••••••"
                required
              />
              <FormPassword
                name="password_confirmation"
                onChange={setForm}
                value={form.password_confirmation}
                label="New Password Confirmation"
                placeholder="••••••"
                required
              />
              <Button
                size="xl"
                primary
                type="submit"
                className="w-full"
                disabled={isLoading}
              >
                Reset Password
              </Button>
            </div>
            <div className="font-semibold mt-5 text-center">
              <a
                className="text-gray-600 border-b border-dashed border-gray-300"
                href="/"
              >
                Back to Login
              </a>
            </div>
            <div className="text-xs font-light mt-10 text-center text-gray-500">
            &copy; 2025 BIR eFPS v.1.0
            </div>
          </Form>
        </div>

        {/* <div className="absolute left-4 right-4 z-10" style={{ bottom: -10 }}>
          <div className="bg-white w-full p-10 rounded-3xl shadow-primary-xl" />
        </div>
        <div className="absolute left-8 right-8 z-0" style={{ bottom: -20 }}>
          <div className="bg-white w-full p-10 rounded-3xl shadow-primary-xl" />
        </div> */}
      </div>
      <div className="fixed bottom-0 w-full text-center">
      <p className="text-gray-400 text-xs">Developed by</p>
      <div className="text-sm font-black">BIR eFPS</div>
        {/* <img src={make} className="h-6 mx-auto mb-12" alt="Brand" /> */}
      </div>
    </div>
  );
}

ResetPassword.propTypes = {};

export default ResetPassword;
